import { Td, Tr } from 'hatch-components';
import React from 'react';
import ContentLoader from 'react-content-loader';

import {
  StyledEditTd,
  StyledId,
  StyledMobilePrefix,
  StyledName,
  StyledNameTd,
} from './styles';

const WorkspaceRowSkeleton = () => {
  return (
    <Tr>
      <StyledNameTd width="25%">
        <StyledName>
          <ContentLoader height={18} width={150}>
            <rect height="18" width="150" x="0" y="0" />
          </ContentLoader>
        </StyledName>
        <StyledId isLoader>
          <ContentLoader height={18} width={150}>
            <rect height="18" width="150" x="0" y="0" />
          </ContentLoader>
        </StyledId>
      </StyledNameTd>
      <Td>
        <StyledMobilePrefix isLoader>
          <ContentLoader height={18} width={100}>
            <rect height="18" width="100" x="0" y="0" />
          </ContentLoader>
        </StyledMobilePrefix>
      </Td>
      <Td>
        <StyledMobilePrefix isLoader />
        <ContentLoader height={36} width={144}>
          <circle cx="18" cy="18" r="18" />
          <circle cx="54" cy="18" r="18" />
          <circle cx="90" cy="18" r="18" />
          <circle cx="126" cy="18" r="18" />
        </ContentLoader>
      </Td>
      <Td>
        <StyledMobilePrefix isLoader>
          <ContentLoader height={18} width={100}>
            <rect height="18" width="100" x="0" y="0" />
          </ContentLoader>
        </StyledMobilePrefix>
      </Td>
      <StyledEditTd width={80} />
    </Tr>
  );
};

WorkspaceRowSkeleton.propTypes = {};

export default WorkspaceRowSkeleton;
